import { Component, OnInit } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiRequestService } from '@core/services/api-request.service';
import { TosterService } from '@core/services/toster.service';
import { Subscription } from 'rxjs';
import { config } from '@core/services/request-url.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { AuthCoreService } from '@page/auth/auth-core.service';
import { DashboardService } from '@page/dashboard/helper/dashboard-service';
import { PermissionService } from '@core/auth/permission/permission.service';

@Component({
  selector: 'app-posp-redirect',
  imports: [ReactiveFormsModule],
  templateUrl: './posp-redirect.component.html',
  styleUrls: ['./posp-redirect.component.scss']
})
export class PospRedirectComponent implements OnInit {

  modalObj: any
  walletData: any;
  wallet_type: FormControl = new FormControl();

  walletSubscription!: Subscription;

  constructor(private apiRequestService: ApiRequestService, private toster:
    TosterService, public activeModal: NgbActiveModal, private _PermissionService: PermissionService, private _DashboardService: DashboardService) { }

  ngOnInit(): void {
    this.getWallet()
  }


  getWallet() {
    let data = {}
    this.walletSubscription = this.apiRequestService.postdata(data, config.POSP.wallet)

      .subscribe((resp: any) => {
        console.log(resp)
        if (resp && resp.statuscode == 200) {
          if (resp.response == 1) {
            this.walletData = resp;
            // this.toster.showSuccess(resp.message)
          }

        } else if (resp.statuscode == 400) {
          if (resp.response == 0) {
            this.toster.showError(resp.message)
          } else if (resp.response == 501) {
            this.toster.showError(resp.message);

          }
        } else {
          this.toster.showError(resp.message)
        }
      });
  }


  onboard() {
    let data = {
      wallet_type: this.wallet_type?.value?.key || '',
      txntoken: this.walletData?.txntoken || ''
    }
    this.walletSubscription = this.apiRequestService.postdata(data, config.POSP.onboarding)

      .subscribe((resp: any) => {
        console.log(resp)
        if (resp && resp.statuscode == 200) {
          if (resp.response == 1) {
            const link = resp?.data;
            window.open(link.alink, '_blank');
            this._DashboardService.userBalance();
            this._PermissionService.permissions();
            this.closeModal()
          }
        } else if (resp.statuscode == 400) {
          this.toster.showError(resp.message)
          this.closeModal()
        } else {
          this.toster.showError(resp.message)
        }
      });
  }


  closeModal() {
    this.activeModal.dismiss('close')
  }






}
